import { Enum_Commande_Status } from '../../graphql/generated/graphql';

export type Status =
  | Enum_Commande_Status.Annule
  | Enum_Commande_Status.APayer
  | Enum_Commande_Status.Paye;

interface StatusChoice {
  id: Status;
  name: string;
}

export const statusChoice: StatusChoice[] = [
  { id: Enum_Commande_Status.APayer, name: 'Non payé' },
  { id: Enum_Commande_Status.Annule, name: 'Annulé' },
  { id: Enum_Commande_Status.Paye, name: 'Payé' }
];
